import { Link } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { ArrowUpRight, Lock } from 'lucide-react';
import { TOOL_CARD, TOOL_OPEN } from '@/constants/testIds';

export function ToolCard({ tool, compact = false }) {
    const Icon = tool.icon;
    const disabled = tool.status !== 'live';
    const body = (
        <Card
            data-testid={TOOL_CARD(tool.slug)}
            className={`group h-full p-4 sm:p-5 border border-border/80 bg-white rounded-xl transition-[box-shadow,border-color,transform] duration-200 ${
                disabled
                    ? 'opacity-80 cursor-not-allowed'
                    : 'hover:border-slate-300 hover:shadow-[0_1px_0_rgba(15,23,42,0.04),0_16px_40px_rgba(15,23,42,0.08)]'
            }`}
        >
            <div className="flex items-start justify-between gap-3">
                <div className="flex items-center gap-3">
                    <span className="inline-flex items-center justify-center w-10 h-10 rounded-lg bg-[hsl(var(--accent))] text-[hsl(var(--primary))]">
                        <Icon className="w-5 h-5" />
                    </span>
                    <div>
                        <h3 className="font-semibold text-slate-900 tracking-tight">
                            {tool.title}
                        </h3>
                        <p className={`mt-0.5 text-sm text-slate-600 ${compact ? 'line-clamp-1' : 'line-clamp-2'}`}>
                            {tool.short}
                        </p>
                    </div>
                </div>
                {disabled ? (
                    <Lock className="w-4 h-4 text-slate-400 shrink-0" aria-hidden />
                ) : (
                    <ArrowUpRight className="w-4 h-4 text-slate-400 group-hover:text-slate-800 transition-colors shrink-0" aria-hidden />
                )}
            </div>
            <div className="mt-4 flex flex-wrap gap-1.5">
                {tool.badges.map((b) => (
                    <Badge
                        key={b}
                        variant="secondary"
                        className="bg-slate-100 text-slate-700 hover:bg-slate-100 font-medium"
                    >
                        {b}
                    </Badge>
                ))}
            </div>
            <div className="mt-4 pt-4 border-t border-border/70 text-sm font-medium">
                <span
                    data-testid={TOOL_OPEN(tool.slug)}
                    className={
                        disabled
                            ? 'text-slate-400'
                            : 'text-[hsl(var(--primary))] group-hover:underline underline-offset-4'
                    }
                >
                    {disabled ? 'Coming soon' : 'Open tool →'}
                </span>
            </div>
        </Card>
    );
    if (disabled) {
        return <div aria-disabled>{body}</div>;
    }
    return (
        <Link to={`/tools/${tool.slug}`} className="block">
            {body}
        </Link>
    );
}
